import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import React from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import useExamRoomActions from "../../../../api/hooks/admin/examRoom";
import { isRaterAddModalOpenState } from "../../../../recoil/admin/examRoom";
import { testRoomSnState } from "recoil/auth";
import RaterAddModal from "../../rater/RaterAddModal";
// 관리자-시험실-평가자탭

const RaterTab = () => {
  const setRaterModalOpen = useSetRecoilState(isRaterAddModalOpenState);
  const selectedTestRoomSn = useRecoilValue(testRoomSnState);
  const queryClient = useQueryClient();
  const { fetchSelectedRaterList, assigningProblem } = useExamRoomActions();
  const examRoomActions = useExamRoomActions();
  const { deleteRater } = useExamRoomActions();

  const { data: raterList } = useQuery({
    queryKey: ["fetchSelectedRaterList", selectedTestRoomSn],
    queryFn: () => fetchSelectedRaterList({ room_sn: selectedTestRoomSn }),
    onSuccess: (res) => {
      console.log("시험실 평가자 리스트 : ", res);
    },
  });

  const deleteRaterList = useMutation(deleteRater, {
    onSuccess: () => {
      queryClient.invalidateQueries(["fetchSelectedRaterList"]);
    },
    onError: () => {
      alert("실패");
    },
  });

  const trashbtnClicked = (sn) => {
    if (window.confirm("추가된 평가자를 삭제합니다.")) {
      deleteRaterList.mutate({ rater_sn: sn, room_sn: selectedTestRoomSn });
      alert("삭제되었습니다.");
    } else {
      alert("취소되었습니다.");
    }
  };

  // 백분율이라 100을 곱하고 소수점은 버림
  const total_100 = (done, total) => {
    if (total === 0) return 0;
    else return parseInt((done / total) * 100);
  };

  return (
    <div className="tab-content">
      <div className="flex filtering">
        <div className="tab-title">
          <p>평가자</p>
        </div>
        <div>
          <button
            className="btn-custom w-btn"
            onClick={async () => {
              if (
                window.confirm(
                  "평가자에게 문제를 할당 하시겠습니까? (1분 정도 소요 될 수 있습니다.)"
                )
              ) {
                const res = await examRoomActions.assigningProblem({
                  room_sn: selectedTestRoomSn,
                });
                if (res.status === 200) {
                  console.log("할당 성공");
                } else {
                  console.log("할당 실패");
                }
              } else {
                alert("취소했습니다.");
              }
            }}
          >
            평가자 문제할당
          </button>

          <button
            type="button"
            className="btn-custom b-btn plus"
            data-bs-toggle="modal"
            data-bs-target="#plus2"
            onClick={() => setRaterModalOpen(true)}
          >
            평가자 등록
          </button>
        </div>
      </div>
      <div className="tableFixHead table-responsive scroll-height-550">
        <div className="height-560">
          <table className="roomtable-content5">
            <thead>
              <tr>
                <th>No.</th>
                <th>이름</th>
                <th>평가완료</th>
                <th>작업</th>
              </tr>
            </thead>
            <tbody>
              {raterList?.data?.map((rater) => (
                <tr key={rater?.id}>
                  <td>{rater?.sn}</td>
                  <td>{rater?.name}</td>
                  <td>
                    <div className="slidecontainer">
                      <input
                        disabled
                        type="range"
                        min="0"
                        max="100"
                        defaultValue={total_100(rater?.done, rater?.total)}
                        className="slider"
                        id="myRange"
                      />
                    </div>
                    <span id="value">
                      {total_100(rater?.done, rater?.total)}%
                    </span>
                    <span className="range-text">
                      {rater?.done}/{rater?.total}
                    </span>
                  </td>
                  <td>
                    <button
                      className="trashbtn"
                      onClick={() => {
                        trashbtnClicked(rater?.sn);
                      }}
                    />
                  </td>
                </tr>
              ))}
              {raterList?.data.length === 0 && (
                <tr>
                  <td colSpan={4}>데이터가 없습니다.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <RaterAddModal />
    </div>
  );
};

export default RaterTab;
